
import './App.css';
import Weather from './Weather';

function App() {
  return (
    
      <div className="App">
    
        <Weather defaultCity="Lisbon"/>
      

      
      
    </div>
   
   
  );
}

export default App;
